import React, { ComponentPropsWithRef } from "react";
import cx from "classnames";

type Props = ComponentPropsWithRef<"hr">;

export default function HorizontalRule({ className, ...rest }: Props) {
  return (
    <hr {...rest} className={cx("border-t-0 max-w-xs mx-auto", className)} />
  );
}
